
import axios, { AxiosResponse } from 'axios';
import urlUtil from '@uarmRoot/src/util-url';

export const defaultZoom = 15; // CWP-25846
/** Пейджа с параметрами для функционирования */
export const apiParamsPageId = 2490801;
/** Кажем Москву (система: 4326, порядок: долгота/широта) */
export const defaultCenter = [37.617, 55.751];
/**
 * Координаты в формате 123456.789 (система 3857) переводим в "нашем" формате 12.3456789 (системе 4326)
 * Порядок: долгота, широта или long, lat
 * @param pos
 * @returns
 */
export function epsg3857toEpsg4326(pos: number[]) {
	let x = pos[0];
	let y = pos[1];
	x = (x * 180) / 20037508.34;
	y = (y * 180) / 20037508.34;
	y = (Math.atan(Math.pow(Math.E, y * (Math.PI / 180))) * 360) / Math.PI - 90;
	return [x, y];
}

export type Coords = [number, number];

export const geomixins = {
	methods: {
		/**
		 * Первичная инициализация (получаем ресурсы и запускаем initMap)
		 */
		async primaryInitMap() {
			console.log(`primaryInitMap!`);
			// Получаем базовые параметры - каждый раз! Потому что иначе, скажем, geoServiceName во второй карте
			// на странице не будет получен (другое дело, что новая админка и одну карту два раза инициализирует)
			let res: AxiosResponse, baseParams: {NAME: string, VALUE: string}[], apiKey: string, scriptUrl: string;
			try {
				res = await axios.get(`${urlUtil.getDomain()}/ru/page/${apiParamsPageId}?mode=json`);
				baseParams = res.data.GIP_BASE_PARAMS.BASE_PARAMETERS;
				const isSpd = res.data.sys.special.user_status === '2';
				const apiKeyParam = isSpd ? 'api_key_spd' : 'api_key';
				apiKey = baseParams.find(bp => bp.NAME === apiKeyParam).VALUE;
				const scriptUrlParam = isSpd ? 'api_url_spd' : 'api_url';
				scriptUrl = baseParams.find(bp => bp.NAME === scriptUrlParam).VALUE;
				this.$data.geoServiceName = baseParams.find(bp => bp.NAME === 'api_service_name').VALUE;
				this.$data.baseMapName = baseParams.find(bp => bp.NAME === 'base_map').VALUE;
				// ...из того же запроса достаём также цвета для точек. Раньше они добывались из пейджи 175610
				this.$data.colorList = res.data.COLORS.CORPORATE_COLOR.map(col => col.NAME);
			} catch (err) {
				this.mixin_errHandler(err);
			}

			if (window['GeoportalApi']) {
				this.initMap();
			}
			else {
				// Подключаем скрипт АПИ ГИП с дальнейшей инициализацией самой карты
				let script = document.querySelector(`script[src="${scriptUrl}"]`);

				if (!script) {
					console.log(`Скрипт ${scriptUrl} не найден. Загружаем...`);
					script = document.createElement('script');
					script.setAttribute('src', scriptUrl);
					script.setAttribute('data-api-key', apiKey);
					document.getElementsByTagName('head')[0].appendChild(script);
				}

				script.addEventListener('load', this.initMap);
				script.addEventListener('error', () => { this.mixin_errHandler(new Error('Ошибка загрузки ресурсов')) });
				// script.onerror = () => { this.mixin_errHandler(new Error('Ошибка загрузки ресурсов')) };
			}
		},
	},
}
